/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Toast_Error2Inputs */

const en_coinvestments_canceldeal_toast_error2 = /** @type {(inputs: Coinvestments_Canceldeal_Toast_Error2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to cancel deal. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to cancel deal. Please try again." |
*
* @param {Coinvestments_Canceldeal_Toast_Error2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_toast_error2 = /** @type {((inputs?: Coinvestments_Canceldeal_Toast_Error2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Toast_Error2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_toast_error2(inputs)
});
export { coinvestments_canceldeal_toast_error2 as "coInvestments_cancelDeal_toast_error" }